import Grid from "@components/Grid/Grid";
import { TypeTabbedContentFields } from "@customTypes/contentful";
import RenderComponents from "@utilities/renderComponents";
import slugify from "@utilities/slugify";
import clsx from "clsx";
import { useRouter } from "next/router";
import { useEffect, useRef, useState } from "react";
import { Tab, TabList, TabPanel, Tabs } from "react-tabs";
import styles from "./C248_TabbedContent.module.scss";

export const TabbedContent = (props: { content: TypeTabbedContentFields }) => {
  const { content } = props;
  const { pageTitle, title, description, tabs, blueBackground, anchorKey } =
    content;
  const [tabIndex, setTabIndex] = useState(0);
  const [didMount, setDidMount] = useState(false);
  const tabsRef = useRef<HTMLElement>(null);
  const { asPath, replace } = useRouter();

  useEffect(() => {
    if (!didMount) {
      setDidMount(true);
      const id = /(#)([a-z]+[\w\-.]*)$/gi.exec(asPath);

      if (!id) return;

      const tabIndex = tabs.findIndex(
        (tab) => slugify(tab.fields.title) === id![2]
      );

      if (tabIndex === -1) return;

      setTabIndex(tabIndex);

      if (tabsRef) tabsRef.current?.scrollIntoView();
      return;
    }

    replace({
      hash: slugify(tabs[tabIndex].fields.title),
    });
  }, [tabIndex]);

  return (
    <div
      className={clsx(
        "component",
        styles["tabbed-content"],
        blueBackground && styles.blue
      )}
    >
      <div className="wrapper">
        <div>
          {pageTitle && (
            <h2 className={styles["small-top-heading"]}>{pageTitle}</h2>
          )}
          {(title || description) && (
            <div className={styles["main-heading-with-intro"]}>
              <Grid row>
                <Grid column md={6}>
                  <h2 id={anchorKey}>{title}</h2>
                </Grid>
                <Grid column md={6}>
                  <p className={styles.description}>{description}</p>
                </Grid>
              </Grid>
            </div>
          )}
        </div>
        <section ref={tabsRef} className={clsx(styles.tabs, "cf")}>
          <Tabs
            selectedIndex={tabIndex}
            onSelect={(index) => setTabIndex(index)}
          >
            <TabList>
              {tabs.map(({ fields: { title } }, index) => (
                <Tab key={`${title}${index}`}>{title}</Tab>
              ))}
            </TabList>

            {tabs.map(({ fields: { content } }, index) => (
              <TabPanel key={`${content}${index}`}>
                {RenderComponents(content)}
              </TabPanel>
            ))}
          </Tabs>
        </section>
      </div>
    </div>
  );
};

export default TabbedContent;
